import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Hizmetlerimiz.css';

const Hizmetlerimiz = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const hizmetler = [
    {
      icon: '🌐',
      baslik: 'Web Geliştirme',
      aciklama: 'Modern, hızlı ve responsive web siteleri',
      detaylar: [
        'Kurumsal web siteleri',
        'E-ticaret platformları',
        'Landing page tasarımı',
        'Web uygulamaları',
        'SEO optimizasyonu'
      ]
    },
    {
      icon: '📱',
      baslik: 'Mobil Uygulama',
      aciklama: 'iOS ve Android için native ve cross-platform uygulamalar',
      detaylar: [
        'Flutter ile cross-platform',
        'React Native geliştirme',
        'Native iOS & Android',
        'UI/UX tasarım',
        'App Store yayınlama'
      ]
    },
    {
      icon: '⚡',
      baslik: 'Backend Geliştirme',
      aciklama: 'Güvenli, ölçeklenebilir ve performanslı backend sistemleri',
      detaylar: [
        'RESTful API geliştirme',
        'Veritabanı tasarımı',
        'Mikroservis mimarisi',
        'Güvenlik entegrasyonu',
        'Cloud deployment'
      ]
    },
    {
      icon: '☁️',
      baslik: 'Bulut Çözümleri',
      aciklama: 'AWS, Google Cloud ve Azure altyapı hizmetleri',
      detaylar: [
        'Cloud migration',
        'Sunucu yönetimi',
        'DevOps & CI/CD',
        'Yedekleme sistemleri',
        'Performans optimizasyonu'
      ]
    },
    {
      icon: '🤖',
      baslik: 'AI & ML',
      aciklama: 'Yapay zeka ve makine öğrenmesi çözümleri',
      detaylar: [
        'Chatbot geliştirme',
        'Veri analizi',
        'Tahminleme modelleri',
        'Görüntü işleme',
        'Doğal dil işleme'
      ]
    },
    {
      icon: '🎨',
      baslik: 'UI/UX Design',
      aciklama: 'Kullanıcı deneyimi odaklı modern tasarımlar',
      detaylar: [
        'Arayüz tasarımı',
        'Kullanıcı deneyimi',
        'Prototipleme',
        'Marka kimliği',
        'Responsive tasarım'
      ]
    }
  ];

  return (
    <div className="hizmetlerimiz-page">
      {/* Header */}
      <header className="main-header">
        <div className="header-container">
          <Link to="/" className="header-logo">
            <img src="/images/logo.png" alt="Logo" />
            <div className="header-logo-text">
              <span className="logo-main">DİGİTALENTRA</span>
              <span className="logo-sub">Software</span>
            </div>
          </Link>
          
          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Menu"
          >
            <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>

          <nav className="nav-menu desktop-only">
            <ul>
              <li><Link to="/">Ana Sayfa</Link></li>
              <li><Link to="/hizmetlerimiz" className="active">Hizmetler</Link></li>
              <li><Link to="/projelerimiz">Projelerimiz</Link></li>
              <li><Link to="/iletisim">İletişim</Link></li>
            </ul>
          </nav>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-fullscreen">
          <button 
            className="mobile-menu-close"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Close Menu"
          >
            <span className="close-icon">
              <span></span>
              <span></span>
            </span>
          </button>
          <nav className="mobile-nav">
            <ul>
              <li><Link to="/" onClick={() => setIsMobileMenuOpen(false)}>Ana Sayfa</Link></li>
              <li><Link to="/hizmetlerimiz" onClick={() => setIsMobileMenuOpen(false)}>Hizmetler</Link></li>
              <li><Link to="/projelerimiz" onClick={() => setIsMobileMenuOpen(false)}>Projelerimiz</Link></li>
              <li><Link to="/iletisim" onClick={() => setIsMobileMenuOpen(false)}>İletişim</Link></li>
            </ul>
          </nav>
        </div>
      )}

      <div className="hizmetler-hero">
        <h1 className="hizmetler-title">Hizmetlerimiz</h1>
        <p className="hizmetler-subtitle">
          Dijital dönüşümünüz için kapsamlı ve profesyonel çözümler sunuyoruz
        </p>
      </div>

      <div className="hizmetler-container">
        <div className="hizmetler-grid">
          {hizmetler.map((hizmet, index) => (
            <div key={index} className="hizmet-card">
              <div className="hizmet-icon">{hizmet.icon}</div>
              <h2 className="hizmet-baslik">{hizmet.baslik}</h2>
              <p className="hizmet-aciklama">{hizmet.aciklama}</p>
              <ul className="hizmet-detaylar">
                {hizmet.detaylar.map((detay, i) => (
                  <li key={i}>{detay}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/images/logo.png" alt="Logo" />
                <span>Digitalentra</span>
              </div>
              <p className="footer-description">
                Modern web siteleri, mobil uygulamalar ve yazılım çözümleri ile işletmenizi dijital dünyaya taşıyoruz.
              </p>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">Hızlı Linkler</h3>
              <ul className="footer-links">
                <li><Link to="/">Ana Sayfa</Link></li>
                <li><Link to="/hizmetlerimiz">Hizmetler</Link></li>
                <li><Link to="/#projects">Projelerimiz</Link></li>
                <li><Link to="/#technologies">Teknolojiler</Link></li>
                <li><Link to="/#contact">İletişim</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">Hizmetlerimiz</h3>
              <ul className="footer-links">
                <li><Link to="/hizmetlerimiz">Web Geliştirme</Link></li>
                <li><Link to="/hizmetlerimiz">Mobil Uygulama</Link></li>
                <li><Link to="/hizmetlerimiz">Backend Geliştirme</Link></li>
                <li><Link to="/hizmetlerimiz">Bulut Çözümleri</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">İletişim</h3>
              <ul className="footer-contact">
                <li>📧 <a href="mailto:info@digitalentrasoftware.com">info@digitalentrasoftware.com</a></li>
                <li>📱 <a href="tel:+905318287339">0531 828 7339</a></li>
                <li>📍 Tekirdağ/Çorlu</li>
              </ul>
              <div className="footer-social">
                <a href="https://www.instagram.com/digitalentrasoftware/" target="_blank" rel="noopener noreferrer" className="social-link">
                  Instagram
                </a>
                <a href="https://wa.me/905318287339" target="_blank" rel="noopener noreferrer" className="social-link social-whatsapp">
                  WhatsApp
                </a>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2025 Digitalentra Software. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>

      {/* Floating Buttons */}
      <div className="floating-buttons">
        <a 
          href="https://wa.me/905318287339" 
          target="_blank" 
          rel="noopener noreferrer"
          className="floating-btn whatsapp-btn"
          aria-label="WhatsApp"
        >
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
          </svg>
        </a>
      </div>
    </div>
  );
};

export default Hizmetlerimiz;
